var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.367,
    height: 39.7,
    viewBox: "0 0 30.367 39.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "robot-8203",
    transform: "translate(-29.776 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M94.431,43.21H83.243a1.369,1.369,0,0,1-1.368-1.368V32.623a1.369,1.369,0,0,1,1.368-1.368H94.431A1.369,1.369,0,0,1,95.8,32.623v9.219A1.369,1.369,0,0,1,94.431,43.21ZM83.243,32.134a.49.49,0,0,0-.49.49v9.219a.49.49,0,0,0,.49.49H94.431a.49.49,0,0,0,.49-.49v-9.22a.491.491,0,0,0-.49-.49H83.243Z",
    transform: "translate(-43.877 -26.374)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M98.97,50.775a1.756,1.756,0,1,1,1.756-1.756A1.757,1.757,0,0,1,98.97,50.775Zm0-2.633a.878.878,0,1,0,.878.878A.879.879,0,0,0,98.97,48.142Z",
    transform: "translate(-56.821 -39.882)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M134.958,50.775a1.756,1.756,0,1,1,1.756-1.756A1.757,1.757,0,0,1,134.958,50.775Zm0-2.633a.878.878,0,1,0,.878.878A.879.879,0,0,0,134.958,48.142Z",
    transform: "translate(-87.188 -39.882)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M70.535,57.212H68.652a.738.738,0,0,1-.737-.737v-4.64a.738.738,0,0,1,.737-.737h1.882a.439.439,0,0,1,.439.439v5.237A.439.439,0,0,1,70.535,57.212Zm-1.742-.878h1.3V51.975h-1.3Z",
    transform: "translate(-32.098 -43.116)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M167.723,57.214h-1.882a.439.439,0,0,1-.439-.439V51.539a.439.439,0,0,1,.439-.439h1.882a.738.738,0,0,1,.738.737v4.64A.738.738,0,0,1,167.723,57.214Zm-1.443-.878h1.3V51.977h-1.3Z",
    transform: "translate(-114.359 -43.119)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M120.02,18.794h-1.843a.439.439,0,0,1-.436-.489l.286-2.469a.439.439,0,0,1,.872.1l-.229,1.98h.858l-.229-1.979a.439.439,0,1,1,.872-.1l.285,2.468a.439.439,0,0,1-.435.489Z",
    transform: "translate(-74.138 -13.035)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M117.108,3.459a1.729,1.729,0,1,1,1.729-1.73A1.731,1.731,0,0,1,117.108,3.459Zm0-2.581a.852.852,0,1,0,.851.851A.853.853,0,0,0,117.108.878Z",
    transform: "translate(-72.148 0)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M111.7,83.171a15.628,15.628,0,0,1-2.822.3,15.227,15.227,0,0,1-2.8-.3.439.439,0,0,1,0-.878,13.173,13.173,0,0,0,2.8.35,13.519,13.519,0,0,0,2.822-.35.439.439,0,0,1,0,.878Z",
    transform: "translate(-63.935 -69.44)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M89.954,133.135h-15.5a.439.439,0,0,1-.439-.439V118.344a.439.439,0,0,1,.439-.439h15.5a.439.439,0,0,1,.439.439V132.7A.438.438,0,0,1,89.954,133.135Zm-15.064-.878H89.515V118.783H74.89Z",
    transform: "translate(-37.243 -99.489)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M75.623,216.527H60.794a3.366,3.366,0,1,1,0-6.733H75.623a3.366,3.366,0,1,1,0,6.733Zm-14.828-5.855a2.489,2.489,0,0,0,0,4.977H75.623a2.489,2.489,0,0,0,0-4.977Z",
    transform: "translate(-23.249 -177.027)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M70.519,224.006a1.618,1.618,0,1,1,1.618-1.618A1.619,1.619,0,0,1,70.519,224.006Zm0-2.357a.74.74,0,1,0,.74.74A.741.741,0,0,0,70.519,221.649Z",
    transform: "translate(-32.93 -186.289)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M164.9,224.006a1.618,1.618,0,1,1,1.618-1.618A1.62,1.62,0,0,1,164.9,224.006Zm0-2.357a.74.74,0,1,0,.74.74A.741.741,0,0,0,164.9,221.649Z",
    transform: "translate(-112.571 -186.289)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M116.1,236.744h-6.6a.439.439,0,1,1,0-.878h6.6a.439.439,0,1,1,0,.878Z",
    transform: "translate(-66.816 -199.026)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M103.4,221.651H96.389a.439.439,0,1,1,0-.878H103.4a.439.439,0,1,1,0,.878Z",
    transform: "translate(-55.754 -186.291)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M107.448,105.509H99.893a.439.439,0,0,1-.439-.439v-2.457a.439.439,0,0,1,.439-.439h7.555a.439.439,0,0,1,.439.439v2.457A.439.439,0,0,1,107.448,105.509Zm-7.116-.878h6.677v-1.579h-6.677Z",
    transform: "translate(-58.711 -86.216)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M32.243,128.441a2.367,2.367,0,0,1-2.364-2.365v-3.882a4.3,4.3,0,0,1,4.29-4.29h3.043a.439.439,0,0,1,.439.439v4.377a.439.439,0,0,1-.439.439H35.559a.953.953,0,0,0-.952.952v1.965A2.367,2.367,0,0,1,32.243,128.441Zm1.925-9.659a3.416,3.416,0,0,0-3.412,3.412v3.882a1.487,1.487,0,1,0,2.973,0v-1.965a1.832,1.832,0,0,1,1.83-1.829h1.213v-3.5h-2.6Z",
    transform: "translate(-0.002 -99.489)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M42.645,181.784a.439.439,0,0,1-.439-.439v-1.161a.439.439,0,1,1,.878,0v1.161A.439.439,0,0,1,42.645,181.784Z",
    transform: "translate(-10.404 -151.67)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M44.568,189.983a.439.439,0,0,1-.439-.439,1.488,1.488,0,0,0-1.487-1.487.439.439,0,0,1,0-.878,2.367,2.367,0,0,1,2.364,2.365A.439.439,0,0,1,44.568,189.983Z",
    transform: "translate(-10.402 -157.944)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M30.315,189.983a.439.439,0,0,1-.439-.439,2.367,2.367,0,0,1,2.364-2.365.439.439,0,0,1,0,.878,1.488,1.488,0,0,0-1.487,1.487A.438.438,0,0,1,30.315,189.983Z",
    transform: "translate(0 -157.944)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M178.672,128.439a2.367,2.367,0,0,1-2.364-2.365v-1.965a.953.953,0,0,0-.952-.952H173.7a.438.438,0,0,1-.439-.439v-4.377a.439.439,0,0,1,.439-.439h3.043a4.3,4.3,0,0,1,4.29,4.29v3.882A2.367,2.367,0,0,1,178.672,128.439Zm-4.529-6.159h1.213a1.832,1.832,0,0,1,1.83,1.829v1.965a1.487,1.487,0,1,0,2.973,0v-3.882a3.416,3.416,0,0,0-3.412-3.412h-2.6v3.5Z",
    transform: "translate(-120.993 -99.487)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M205.513,181.784a.439.439,0,0,1-.439-.439v-1.161a.439.439,0,1,1,.878,0v1.161A.439.439,0,0,1,205.513,181.784Z",
    transform: "translate(-147.834 -151.67)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M193.188,189.983a.438.438,0,0,1-.439-.439,2.367,2.367,0,0,1,2.364-2.365.439.439,0,0,1,0,.878,1.489,1.489,0,0,0-1.487,1.487A.439.439,0,0,1,193.188,189.983Z",
    transform: "translate(-137.434 -157.944)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M207.439,189.983a.438.438,0,0,1-.439-.439,1.489,1.489,0,0,0-1.487-1.487.439.439,0,1,1,0-.878,2.367,2.367,0,0,1,2.365,2.365A.438.438,0,0,1,207.439,189.983Z",
    transform: "translate(-147.834 -157.944)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M113.618,149.7h-4.752a.439.439,0,0,1,0-.878h4.752a.439.439,0,0,1,0,.878Z",
    transform: "translate(-66.282 -125.579)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M113.618,165.434h-4.752a.439.439,0,1,1,0-.878h4.752a.439.439,0,1,1,0,.878Z",
    transform: "translate(-66.282 -138.855)",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotMenu);
export default __webpack_public_path__ + "static/media/bot-menu.f7c3719ee8eaec50abb7b2f44a483d51.svg";
export { ForwardRef as ReactComponent };